import { ORDER_PAGE as dict } from '@/resources/dict'
import { deliveryTypeEnum } from '@/resources/enums/deliveryTypes'
import { checkoutTypeEnumFullName } from '@/resources/enums/checkoutType'
import { PaymentType } from '@/resources/enums/paymentType'
import orderStatusEnum, {
  OrderExtraStatus,
} from '@/resources/enums/orderStatus'
import { parseUTCDate } from '@/resources/utils/global'

export const isOnlinePayment = paymentType => {
  return (
    paymentType === PaymentType.ONLINE_PAYMENT ||
    paymentType === PaymentType.PIX ||
    paymentType === PaymentType.NUPAY
  )
}

export const getOnlinePaymentText = paymentType => {
  switch (paymentType) {
    case PaymentType.PIX:
      return dict.paymentType.pix
    case PaymentType.NUPAY:
      return dict.paymentType.nupay
    case PaymentType.ONLINE_PAYMENT:
    default:
      return dict.paymentType.onlinePayment
  }
}

export const isPending = status => status === orderStatusEnum.PENDING

export const getStatusLabel = status => dict.statusLabel[status]

export const getReasonLabel = reason => dict.reasonLabel[reason]

const parseEventTimestampProp = ({ timestamp }) =>
  parseUTCDate(timestamp, 'HH:mm')

const parseEventStateProp = ({ state, email }) => {
  let parsedStatus = dict.eventState[state]
  if (!email) parsedStatus = dict.eventState['NO_ANSWER_AND_EMAIL']
  return parsedStatus
}

const parseStatusEvent = eventStatus => ({
  ...eventStatus,
  timestamp: parseEventTimestampProp(eventStatus),
  state: parseEventStateProp({ ...eventStatus }),
})

export const mapStatusEvents = statusEvents =>
  statusEvents
    ?.map(statusEvent => statusEvent?.event)
    ?.map(item => item.map(eventItem => eventItem))
    ?.map(events => events.reduce((a, b) => ({ ...a, [b.key]: b.value }), {}))
    ?.map(event => parseStatusEvent(event))

export const orderStatusExtraLabel = Object.freeze({
  [`${deliveryTypeEnum.RECEIVE},${orderStatusEnum.POC_ACCEPTED}`]:
    OrderExtraStatus.WAITING_COURIER,

  [`${deliveryTypeEnum.PICKUP},${orderStatusEnum.POC_ACCEPTED}`]:
    OrderExtraStatus.WAITING_CONSUMER,
})

export const isCbe = (checkoutType = checkoutTypeEnumFullName.DEFAULT) =>
  checkoutType === checkoutTypeEnumFullName.CBE
